import ArrayTransform from 'ember-data-model-fragments/transforms/array';
export default ArrayTransform;
